import DOMPurify from 'dompurify';
import { sanitizeRichHtml } from './quiz-html-utils';

/**
 * Sanitizes HTML content to prevent XSS attacks while preserving rich formatting.
 * This is the default sanitizer used across all quiz/exam players.
 * It supports SVGs, tables, styled divs, and other rich HTML from uploaded documents.
 * @param html - The HTML string to sanitize
 * @returns Sanitized HTML string safe for rendering
 */
export function sanitizeHtml(html: string): string {
  if (!html) return '';
  return sanitizeRichHtml(html);
}

/**
 * Creates a safe component for rendering sanitized HTML
 */
export function createSafeHtml(html: string) {
  return { __html: sanitizeHtml(html) };
}
